// extracted by mini-css-extract-plugin
export default {"layout":"MainLayout_layout__4814U","header":"MainLayout_header__E+IZJ"};